import PageHero from "../components/PageHero";

const CASES = [
  {
    title: "NRI Couple → Coorg Staycation Villa",
    client: "NRI Family, Dubai",
    result: "₹1.35 Cr outlay · 28% net yield",
    period: "18 months to first income",
    image: "https://readdy.ai/api/search-image?query=Premium%20wooden%20A-frame%20villa%20with%20floor%20to%20ceiling%20glass%20set%20among%20coffee%20plantations%20in%20Coorg%20misty%20morning%20light%2C%20landscaped%20deck%2C%20warm%20golden%20tones%2C%20stylized%20architectural%20render%2C%20high%20detail&width=900&height=640&seq=case-01&orientation=landscape",
    story:
      "A Dubai-based NRI couple wanted a holiday home that paid for itself. They reserved an Aurora A-frame in our Coorg project, financed modular construction in stages, and put it on our managed staycation network. Today it runs at strong seasonal occupancy while they enjoy six weeks of personal stays a year.",
    stats: [
      { k: "Net yield", v: "28%" },
      { k: "Occupancy", v: "70%" },
      { k: "Personal stays", v: "6 wks" },
    ],
  },
  {
    title: "Bengaluru Doctor → Munnar Resort Cluster",
    client: "Orthopaedic Surgeon, Bengaluru",
    result: "₹2.4 Cr · 3-villa resort cluster",
    period: "24 months to stabilized returns",
    image: "https://readdy.ai/api/search-image?query=Cluster%20of%20three%20modern%20A-frame%20villa%20cabins%20on%20a%20misty%20Munnar%20hillside%20tea%20estate%20at%20sunrise%2C%20warm%20amber%20light%2C%20wooden%20architecture%2C%20stylized%20artistic%20render%2C%20high%20detail&width=900&height=640&seq=case-02&orientation=landscape",
    story:
      "A surgeon diversified into hospitality by co-investing in a three-villa resort cluster near Munnar. Nomad Livings handled design, construction and resort management end to end, while a shared housekeeping and booking model kept running costs low. Rental income now comfortably covers his EMI and expenses.",
    stats: [
      { k: "Villas", v: "3" },
      { k: "Running costs", v: "Low" },
      { k: "Income cover", v: "EMI + more" },
    ],
  },
  {
    title: "Retired Couple → Wayanad Dual-Use Home",
    client: "Retired Professionals, Kochi",
    result: "₹98 L · 38% projected payback",
    period: "12 months to handover",
    image: "https://readdy.ai/api/search-image?query=Charming%20wooden%20A-frame%20villa%20with%20open%20veranda%20overlooking%20lush%20Wayanad%20valley%2C%20warm%20golden%20late%20afternoon%20light%2C%20cosy%20interior%20glow%2C%20stylized%20architectural%20render%2C%20high%20detail&width=900&height=640&seq=case-03&orientation=landscape",
    story:
      "A retired couple wanted a place to escape Kerala's summers and a sensible store of wealth. They picked a Havenside model in Wayanad for personal stays, renting it through our platform for the rest of the year. Between appreciation and holiday income, they project a full payback in just under four years.",
    stats: [
      { k: "Entry outlay", v: "₹98 L" },
      { k: "Projected payback", v: "38%" },
      { k: "Dual use", v: "Stay + rent" },
    ],
  },
];

export default function CaseStudies() {
  return (
    <div className="w-full">
      <PageHero
        eyebrow="Investor Stories"
        title={
          <>
            Real Villas, Real <span className="italic text-accent-300">Returns</span>
          </>
        }
        subtitle="A few examples of how investors across India are turning modular A-frame villas into staycations, holiday income and lasting wealth."
      />

      <section className="w-full py-12 md:py-16 bg-background-50">
        <div className="w-full px-4 md:px-8 max-w-7xl mx-auto space-y-10">
          {CASES.map((c) => (
            <article
              key={c.title}
              className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-10 rounded-3xl bg-background-100 border border-background-200 overflow-hidden"
            >
              <div className="relative h-64 lg:h-auto w-full overflow-hidden">
                <img src={c.image} alt={c.title} className="w-full h-full object-cover" />
              </div>
              <div className="p-6 md:p-10 flex flex-col justify-center">
                <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-wide uppercase text-primary-600">
                  <i className="ri-user-heart-line"></i> {c.client}
                </span>
                <h3 className="font-heading text-2xl md:text-3xl text-foreground-950 mt-3">{c.title}</h3>
                <p className="text-foreground-600 text-sm md:text-base mt-4 leading-relaxed">{c.story}</p>
                <div className="mt-6 grid grid-cols-3 gap-3">
                  {c.stats.map((s) => (
                    <div key={s.k} className="rounded-xl bg-background-50 border border-background-200 p-3 text-center">
                      <p className="font-heading text-xl font-bold text-primary-700">{s.v}</p>
                      <p className="text-[11px] uppercase tracking-wide text-foreground-600 mt-0.5">{s.k}</p>
                    </div>
                  ))}
                </div>
                <div className="mt-5 flex items-center gap-2 text-sm text-foreground-700">
                  <i className="ri-time-line text-primary-600"></i> {c.period}
                </div>
              </div>
            </article>
          ))}

          <div className="rounded-2xl bg-primary-100 border border-primary-200 p-6 md:p-8 text-center">
            <h4 className="font-heading text-xl text-foreground-950">Your villa journey could start here.</h4>
            <p className="text-sm text-foreground-700 mt-2">
              Browse our villa models and see which one fits your goals and budget.
            </p>
            <a
              href="/listings"
              className="inline-flex items-center gap-2 text-sm font-semibold whitespace-nowrap rounded-full bg-primary-600 text-background-50 px-6 py-3 mt-4 hover:bg-primary-700 transition-colors"
            >
              Explore Villa Models <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}